import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { itemsApi } from '../api/items';
import { PageHeader } from '../components/ui/PageHeader';
import { SkeletonList } from '../components/ui/Skeleton';
import { EmptyState } from '../components/ui/EmptyState';
import { formatDate, formatCurrency } from '../utils/format';

export function PriceHistoryScreen() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const { data: item } = useQuery({
    queryKey: ['items', id],
    queryFn: () => itemsApi.get(id!),
    enabled: Boolean(id),
    staleTime: 60_000,
  });

  const { data: priceHistory, isLoading } = useQuery({
    queryKey: ['items', id, 'price-history'],
    queryFn: () => itemsApi.priceHistory(id!),
    enabled: Boolean(id),
    staleTime: 60_000,
  });

  return (
    <div className="flex flex-col min-h-screen pb-[calc(4rem+env(safe-area-inset-bottom)+1.5rem)]">
      <PageHeader
        title={item?.name ?? 'Histórico de Preços'}
        showBack
        subtitle={item ? 'Histórico de preços' : undefined}
      />

      <div className="flex-1 px-4 py-4">
        {isLoading ? (
          <SkeletonList count={4} />
        ) : !priceHistory || priceHistory.length === 0 ? (
          <EmptyState
            title="Nenhum histórico"
            description="Os preços das compras aparecerão aqui."
          />
        ) : (
          <div className="space-y-2">
            {priceHistory.map((record) => (
              <div
                key={record.id}
                className="bg-white rounded-2xl shadow-sm border border-gray-100 p-4"
              >
                <div className="flex items-center justify-between">
                  <div>
                    <p className="font-bold text-gray-900 text-base">
                      {formatCurrency(record.unitPrice)}
                    </p>
                    <p className="text-sm text-gray-500 mt-0.5">
                      {record.storeName} · {formatDate(record.purchaseDate)}
                    </p>
                  </div>
                  <div className="text-right">
                    <p className="text-sm text-gray-600">Qtd: {record.quantityBought}</p>
                    {record.totalPrice && (
                      <p className="text-xs text-gray-400">
                        Total: {formatCurrency(record.totalPrice)}
                      </p>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
